import { getSharedStyleSheet } from './sharedStyleSheet.js';

class PopOver extends HTMLElement {
    static observedAttributes = [];
    closed = false;
    mouseEntered = false;
    showing = false;

    constructor() {
        super();
    }

    attributeChangedCallback(attrName, oldValue, newValue) {
        this.dynamicRender();
    }

    connectedCallback() {
        if (!this.shadowRoot) {
            this.attachShadow({mode: 'open', delegatesFocus: true});

            // Share a single parsed stylesheet across all shadow roots
            getSharedStyleSheet().then(sheet => {
                this.shadowRoot.adoptedStyleSheets = [sheet];
            });

            // Transparent background to get click events
            if (!!!this.getAttribute('no-background')) {
                this._bg = document.createElement('div');
                this._bg.className = 'popover-background';
                this.shadowRoot.appendChild(this._bg);
            }

            this._wrapper = document.createElement('div');
            this._wrapper.className = 'popover';
            this._wrapper.role = 'dialog';
            this._wrapper.ariaLabel = 'PopOver';
            this.shadowRoot.appendChild(this._wrapper);

            this._contentWrapper = document.createElement('div');
            this._contentWrapper.className = 'popover-content';
            this._wrapper.appendChild(this._contentWrapper);

            this._slot = document.createElement('slot');
            this._slot.style.display = 'none';
            this._contentWrapper.appendChild(this._slot);

            this.setupEvents();
        }

        this.dynamicRender();

        this.show();
    }

    setupEvents() {
        if (!!!this.getAttribute('no-background')) {
            this._bg.addEventListener('click', e => {
                this.close();
            });

            if (!!this.getAttribute('close-on-mouseleave')) {
                this._bg.addEventListener('mousemove', e => {
                    if (!this.showing) return;

                    // Ignore if we're still in the bounds
                    const rect = this._wrapper.getBoundingClientRect();

                    const mouseX = e.clientX;
                    const mouseY = e.clientY;

                    let leftPosition = Math.floor(rect.left);
                    let rightPosition = Math.floor(leftPosition + rect.width);
                    let topPosition = Math.floor(rect.top);
                    let bottomPosition = Math.floor(topPosition + rect.height);

                    // Add margin
                    leftPosition *= 0.9;
                    rightPosition *= 1.1;
                    topPosition *= 0.9;
                    bottomPosition *= 1.1;

                    let withinBounds = mouseX >= leftPosition && mouseX < rightPosition
                        && mouseY >= topPosition && mouseY < bottomPosition;

                    if (withinBounds) {
                        return;
                    }

                    this.close();
                });
            }
        }

        this._wrapper.addEventListener('keyup', e => {
            if (e.key === 'Escape') {
                this.close();
            }
        })
    }

    dynamicRender() {

    }

    async show() {
        console.log('show');
        const width = +this.getAttribute('width') ?? 100;
        const height = +this.getAttribute('height') ?? 100;
        let xPos = +this.getAttribute('atX') ?? 0;
        let yPos = +this.getAttribute('atY') ?? 10;

        let initialXPos = xPos;
        let finalXPos = xPos - (width / 2);
        let initialYPos = yPos;
        let finalYPos = yPos;

        let direction = this.getAttribute('direction') ?? 'auto';

        // Figure out direction
        if (direction === "auto") {
            if (yPos + height >= document.body.offsetHeight * 0.95) {
                direction = 'above';
            } else {
                direction = 'below';
            }
        }

        if (direction === "above") {
            this._wrapper.classList.add('above');
            initialYPos = yPos - 10;
            finalYPos = yPos - 10 - height;
        }

        if (finalXPos < 0) finalXPos = 0;

        this._wrapper.style.width = '0';
        this._wrapper.style.height = '0';
        this._wrapper.style.left = initialXPos + 'px';
        this._wrapper.style.top = initialYPos + 'px';

        this.animation = this._wrapper.animate([
            { width: width + 'px', height: height + 'px', left: finalXPos + 'px', top: finalYPos + 'px' }
        ],{ duration: 200, iterations: 1, fill: 'forwards'});

        // Wait for the animation to finish
        try {
            await this.animation.finished;
        } catch {
            // Do nothing
        }

        // Commit animation state to style attribute
        if (!this.closed) {
            this.animation.commitStyles();
        }

        // Cancel the animation
        this.animation.cancel();
        this.animation = null;

        // Show content
        this._slot.style.display = 'block';

        this.showing = true;

        this._contentWrapper.tabIndex = 0;
        this._contentWrapper.focus();
/*
        const contentAnimation = this._slot.animate([
            { opacity: 1.0 }
        ],{ duration: 100, iterations: 1, fill: 'forwards'});

        await contentAnimation.finished;

        contentAnimation.commitStyles();
        contentAnimation.cancel();
 */
    }

    async close(immediately = false) {
        console.log('close');
        this.closed = true;
        if (this.animation) this.animation.cancel();

        if (!immediately) {
            const animation = this._wrapper.animate([
                {opacity: 0}
            ], {duration: 100, iterations: 1, fill: 'forwards'});

            // Wait for the animation to finish
            try {
                await animation.finished;

                // Commit animation state to style attribute
                animation.commitStyles();
            } catch {
                // Do nothing
            }

            // Cancel the animation
            animation.cancel();
        }

        // Kill element
        this.shadowRoot.host.remove();
    }
}

customElements.define('pop-over', PopOver);

